<template>
  <div>
    <transactions-table
      showSelect
      :tableName="tableName"
      :columns="columns"
      :actionsList="actionsList"
      @showReceiptModal="showReceiptModal"
      @showDetailTransactionModal="showTransactionModal"
      @showTransactionModal="showTransactionModal"
      @showMileageModal="showCreateMileageModal"
      @showDietModal="showDietModal"
      @showExpenseModal="showCreateExpenseModal"
    ></transactions-table>
    <transaction-edit-modal
      v-if="showTransactionsEditModalFlag"
      :open.sync="showTransactionsEditModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @showTransactionModal="showTransactionModal"
    ></transaction-edit-modal>
    <transaction-receipts-viewer-modal
      v-if="showTransactionReceiptModalFlag"
      :open.sync="showTransactionReceiptModalFlag"
      :preloadReceiptId="preloadReceiptId"
      :transactionId.sync="transactionToShowReceiptId"
    ></transaction-receipts-viewer-modal>
  </div>
</template>

<script>
import { BULK_FUNNEL_ACTIONS } from '@/constants/reviewStatus'
import TransactionsTable from '@/modules/transactions/_components/_shared/TransactionsTable'
import TransactionEditModal from '@/modules/transactions/_components/_shared/TransactionsEditModal'
import TransactionReceiptsViewerModal from '@/modules/transactions/_components/_shared/TransactionReceiptsViewerModal'
import _transactionsIndexViewShared from '../../../transactions/_mixins/_transactionsIndexViewShared'

import { segmentTrack } from '@/analytics/segment'

export default {
  name: 'UserTransactions',
  components: {
    TransactionsTable,
    TransactionEditModal,
    TransactionReceiptsViewerModal
  },
  mixins: [
    _transactionsIndexViewShared
  ],
  data () {
    return {
      showTransactionsEditModalFlag: false,
      showTransactionReceiptModalFlag: false,
      transactionToEditId: 0,
      preloadReceiptId: 0,
      transactionToShowReceiptId: 0,
      showConfirmDeleteTransactionModalFlag: false,
      showEditMileageModalFlag: false,
      showEditExpenseModalFlag: false,
      showEditDietModalFlag: false,
      showExpenseReceiptPreviewModalFlag: false,
      tableName: 'transactions',
      actionsList: [
        BULK_FUNNEL_ACTIONS.LOCK,
        BULK_FUNNEL_ACTIONS.UNLOCK,
        BULK_FUNNEL_ACTIONS.UNREVIEW,
        BULK_FUNNEL_ACTIONS.APPROVE,
        BULK_FUNNEL_ACTIONS.ACCOUNT
      ]
    }
  },
  computed: {
    userId () {
      return this.$route.params.id || ''
    },
    budgets () {
      return this.$store.getters['BudgetsStore/budgets'] || []
    },
    columns () {
      return this.$store.getters['TransactionsStore/tableColumns'].filter(item => item.table ? item.table.includes(this.tableName) : item)
    }
  },
  methods: {
    async fetchTransactions () {
      const defaultFilters = {
        'card.user.id': this.userId,
        'status.code': ['OK', 'PENDING'],
        'type.code': 'NORMAL',

        'amountDistinctZero': true
      }
      await this.$store.dispatch('TransactionsStore/setTransactionsFilters', { filters: defaultFilters })
    },
    showEditTransactionModal (event) {
      this.transactionToEditId = event
      this.showTransactionsEditModalFlag = true
    },
    showConfirmDeleteTransactionModal (event) {
      this.showConfirmDeleteTransactionModalFlag = true
      this.transactionToEditId = event
    },
    showCreateMileageModal (event) {
      this.transactionToEditId = event
      this.showEditMileageModalFlag = true
    },
    showCreateExpenseModal (event) {
      this.transactionToEditId = event
      this.showEditExpenseModalFlag = true
    },
    showDietModal (event) {
      this.transactionToEditId = event
      this.showEditDietModalFlag = true
    },
    handleCloseTransactionReceiptModal () {
      if (this.showTransactionReceiptModalFlag) {
        this.showTransactionReceiptModalFlag = false
        this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', false)
      }
    },

    async deleteTransaction () {
      await this.$store.dispatch('TransactionsStore/deleteTransaction', this.transactionToEditId)
      this.showTransactionsEditModalFlag = false
      this.showEditDietModalFlag = false
      this.showEditExpenseModalFlag = false
      this.showEditMileageModalFlag = false
      this.showConfirmDeleteTransactionModalFlag = false
    }

  },
  async created () {
    this.$store.dispatch('TransactionsStore/clearStore')
    await this.fetchTransactions()
    segmentTrack('User transactions opened', {
      member_transactions_charged_count: this.$store.getters['TransactionsStore/totalItems']
    })
    if (this.budgets.length === 0) {
      this.$store.dispatch('BudgetsStore/fetchBudgets', false)
    }
  }
}
</script>
<style src="@/assets/styles/multiselect/multiselect-section-selector.css" scoped >
</style>
